import React from "react";
import {AnimatePresence, motion} from "framer-motion";
import styles from "./Apps.module.css";

export default function StatusIcon({released}: { released: boolean }) {
    return (
        <span className={styles.statusIcon} role="img" aria-label={released ? "Released" : "Draft"}>
            <AnimatePresence initial={false} mode="wait">
                {released ? (
                    <motion.svg
                        key="released"
                        viewBox="0 0 16 16"
                        width="16"
                        height="16"
                        initial={{scale: 0.4, opacity: 0}}
                        animate={{scale: 1, opacity: 1}}
                        exit={{scale: 0.4, opacity: 0}}
                        transition={{duration: 0.15, ease: [0.16, 1, 0.3, 1]}}
                    >
                        <circle cx="8" cy="8" r="7" fill="var(--success)"/>
                        <path d="M5 8.2l2 2 4-4.2" fill="none" stroke="var(--surface)" strokeWidth="1.6"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </motion.svg>
                ) : (
                    <motion.svg
                        key="draft"
                        viewBox="0 0 16 16"
                        width="16"
                        height="16"
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        exit={{opacity: 0}}
                        transition={{duration: 0.12}}
                    >
                        <circle cx="8" cy="8" r="6.25" fill="none" stroke="var(--text-3)" strokeWidth="1.5"
                                strokeDasharray="2.6 2.3"/>
                    </motion.svg>
                )}
            </AnimatePresence>
        </span>
    );
}
